import React from "react";
import styled from "styled-components";

import {PrimaryButton} from "../../elements/Buttons";

const dummyOnClick = e => {
};

const ButtonElement = styled(PrimaryButton)`
    display: flex;
    align-items: center;
`;

export const BackToOverviewButton = ({onClick = dummyOnClick}) => {
    return <ButtonElement onClick={onClick} className="t-collapse-button">
        <span>Back to Overview</span>
    </ButtonElement>;
};
